import { constants } from "../constants/redux-constants";

const initialState = {
  patientDashboard: {
    isVisible: false,
    isDisabled: false,
  },
  sidebar: {
    isVisible: false,
  },
  renderer: 1,
};

const quickAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.QUICK_ACCESS.PATIENT_DASHBOARD.SET_IS_VISIBLE:
      return {
        ...state,
        patientDashboard: {
          ...state.patientDashboard,
          isVisible: action.payload,
        },
      };
    case constants.QUICK_ACCESS.PATIENT_DASHBOARD.SET_IS_DISABLED:
      return {
        ...state,
        // value: state.value + 1,
        patientDashboard: {
          ...state.patientDashboard,
          isDisabled: action.payload,
        },
      };
    case constants.QUICK_ACCESS.RESET:
      return initialState;
    case constants.QUICK_ACCESS.CLOSE_OVERLAY:
      return {
        ...state,
        renderer: state?.renderer + 1,
      };
    case constants.QUICK_ACCESS.SIDEBAR.SET_IS_VISIBLE:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          isVisible: action.payload,
        },
      };
    default:
      return state;
  }
};

export default quickAccessReducer;
